import Paper from "@mui/material/Paper"
import Stack from "@mui/material/Stack"
import type { Bus } from "./lib/Bus"
import { PancakeStack } from "./PancakeStack"
import { PollNavigation } from "./PollNavigation"
import type { PollCRDT } from "./poll"
import { phenom } from "./poll"
import { MapView } from "./MapView"
import { PageTitle } from "./lib/PageTitle"

export function MapController({ pollBus }: { pollBus: Bus<PollCRDT> }) {
  const poll = phenom({ ...pollBus.state.get(), id: pollBus.id })

  return (
    <>
      <PageTitle value={poll.title ? `Map: ${poll.title} |` : "Druthers Map"} />
      <PancakeStack>
        <Paper>
          <Stack p={2}>
            <span style={{ fontWeight: 600, fontSize: "1.1rem" }}>
              {poll.title || "Map View"}
            </span>
          </Stack>
        </Paper>
        <MapView items={poll.candidates} />
        <PollNavigation pollID={poll.id} nav="map" />
      </PancakeStack>
    </>
  )
}
